<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Partnerek</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/data/partners/add')"
        icon="el-icon-plus"
        v-can="'partner.create'"
      >
        Új Partner
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="partner/fetchAll"
      />
    </div>
    <partner-list v-if="filterConfig" />
    <template v-if="$route.meta.showAddPartnerDialog">
      <partner-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdatePartnerDialog">
      <partner-dialog
        :partnerId="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
import PartnerList from '../../components/data/partners/List';
import PartnerDialog from '../../components/data/partners/Dialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    PartnerList,
    PartnerDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    if (this.$route.query) {
      const queryString = Object.keys(this.$route.query).map((key) => key + '=' + this.$route.query[key]).join('&');
      this.$store.commit('partner/setFilterString', queryString);
    } else {
      this.$store.commit('partner/setFilterString', '');
    }
    await this.setConfig();
  },
  methods: {
    async setConfig() {
      let customerGroup = this.$store.getters['customerGroup/customerGroups'];
      if (!customerGroup.length) {
        await this.$store.dispatch('customerGroup/fetchAll', '');
        customerGroup = this.$store.getters['customerGroup/customerGroups'];
      }
      this.filterConfig = [
        {
          type: 'text',
          name: 'name',
          label: 'Hivatalos név',
          defaultSearch: true,
        },
        {
          type: 'text',
          name: 'id',
          label: 'ID',
        },
        {
          type: 'text',
          name: 'short_name',
          label: 'Rövid név',
        },
        {
          type: 'text',
          name: 'address',
          label: 'Cím',
        },
        {
          type: 'text',
          name: 'felir',
          label: 'FELIR',
        },
        {
          type: 'text',
          name: 'tax_number',
          label: 'Adószám',
        },
        {
          type: 'text',
          name: 'eu_tax_number',
          label: 'EU adószám',
        },
        {
          type: 'text',
          name: 'group_tax_number',
          label: 'Csoportos adószám',
        },
        {
          type: 'text',
          name: 'registration_number',
          label: 'Cégjegyzékszám',
        },
        {
          type: 'select',
          options: customerGroup,
          name: 'customer_group_id',
          label: 'Vevőcsoport',
          labelCallback: group => group && group.name || '',
          valueKey: 'id',
        },
      ];
    },
  },
};
</script>
